












import { Component, Vue } from 'vue-property-decorator';
import Address from '@/components/common/Address.vue';

@Component({
    components: {
        Address,
    },
})
export default class PlugimmoAddress extends Vue {}
